import { Action } from "redux";
import { ThunkAction } from "redux-thunk";

import {
  IActionsSetRetentionFactorData,
  IActionsSetCategories,
  IActionsSetReferenceMeasures,
  IActionsSetNutrientData,
  IActionsSetDataSources,
} from "../actions/referenceData";
import {
  NutrientMap,
  RetentionFactorProfileMap,
  CategoryMap,
  ReferenceMeasureMap,
  RetentionFactorGroupMap,
  DataSourceMap,
} from "../reducers/referenceData";
import {
  setRetentionFactorData,
  setNutrientData,
  setCategories,
  setReferenceMeasures,
  setDataSources,
} from "../action-creators/referenceData";
import { RootState } from "../../reducers";
import { ExtraArguments } from "../../store";

export const fetchReferenceData = (): ThunkAction<
  Promise<void>,
  RootState,
  ExtraArguments,
  Action<any>
> => async (dispatch) => {
  await dispatch(fetchNutrientData());
  await dispatch(fetchCategoryData());
  await dispatch(fetchReferenceMeasureData());
  await dispatch(fetchRetentionFactorData());
  await dispatch(fetchDataSourcesData());
};

export const fetchNutrientData = (): ThunkAction<
  Promise<void>,
  RootState,
  ExtraArguments,
  IActionsSetNutrientData
> => async (dispatch, getState, { firebase, routing }) => {
  const nutrientData: NutrientMap = await firebase!.referenceData.doFetchNutrients();

  dispatch(setNutrientData(nutrientData));
};

export const fetchCategoryData = (): ThunkAction<
  Promise<void>,
  RootState,
  ExtraArguments,
  IActionsSetCategories
> => async (dispatch, getState, { firebase, routing }) => {
  const categoryData: CategoryMap = await firebase!.referenceData.doFetchCategories();

  dispatch(setCategories(categoryData));
};

export const fetchReferenceMeasureData = (): ThunkAction<
  Promise<void>,
  RootState,
  ExtraArguments,
  IActionsSetReferenceMeasures
> => async (dispatch, getState, { firebase, routing }) => {
  const referenceMeasureData: ReferenceMeasureMap = await firebase!.referenceData.doFetchReferenceMeasures();

  dispatch(setReferenceMeasures(referenceMeasureData));
};

export const fetchRetentionFactorData = (): ThunkAction<
  Promise<void>,
  RootState,
  ExtraArguments,
  IActionsSetRetentionFactorData
> => async (dispatch, getState, { firebase, routing }) => {
  const profileMap: RetentionFactorProfileMap = await firebase!.referenceData.doFetchRetentionFactorProfiles();

  const groupMap: RetentionFactorGroupMap = await firebase!.referenceData.doFetchRetentionFactorGroups();

  dispatch(
    setRetentionFactorData({
      retentionFactorProfileMap: profileMap,
      retentionFactorGroupMap: groupMap,
    })
  );
};

export const fetchDataSourcesData = (): ThunkAction<
  Promise<void>,
  RootState,
  ExtraArguments,
  IActionsSetDataSources
> => async (dispatch, getState, { firebase, routing }) => {
  const dataSourceMap: DataSourceMap = await firebase!.referenceData.doFetchDataSources();

  dispatch(setDataSources(dataSourceMap));
};
